function initState() {
  return {
    currentNetwork: "",
  };
}

const state = initState();

const mutations = {
  SET_CURRENT_NETWORK(state, network) {
    state.currentNetwork = network;
  },
};

const actions = {
  async PING() {
    const url = `/api/v1/ping`;
    try {
      const response = await this.$customApiService().get(url);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_VERSION() {
    const url = `/api/v1/version`;
    try {
      const response = await this.$customApiService().get(url);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SEARCH(_, { queryParam, currentNetwork }) {
    const query = new URLSearchParams({
      q: queryParam,
      blockchain: currentNetwork,
    });
    const url = `/api/v1/search?${query}`;
    try {
      const response = await this.$authlessApiService().get(url, {
        timeout: 5000,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_ADDRESS(_, { network, address }) {
    const url = `/api/v1/${network}/address/${address}`;
    try {
      const response = await this.$authlessApiService().get(url, {
        timeout: 5000,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_TRANSACTION(_, { network, hash }) {
    const url = `/api/v1/${network}/transaction/${hash}`;
    try {
      const response = await this.$authlessApiService().get(url, {
        timeout: 5000,
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_INSTANT_TRANSACTION(_, { payload }) {
    const url = `/api/v1/transactions/instant/${payload}`;
    try {
      const response = await this.$authlessApiService().get(url);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_AVAILABLE_NETWORKS() {
    const url = `/api/v1/blockchains`;
    try {
      const response = await this.$authlessApiService().get(url);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_NEWS() {
    // const url = `/api/v1/news`;
    try {
      // const response = await this.$authlessApiService().get(url, {
      //   timeout: 5000,
      // });
      return Promise.resolve(); // MOCKS news - import { news } from "../mocks";
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

const getters = {
  getCurrentNetwork: (state) => state.currentNetwork,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
